import { Box } from "@mui/material";
import { useContext } from "react";
import { ContextTest } from "./CredListView";
import {
  addCredItem,
  updateCredItem,
  deleteCredItem,
} from "../controllers/CredController";

export default function CredItemModalButtons(props) {
  const {
    isEditable,
    isNewCredItem,
    setIsEditable,
    activeCredItem,
    credListViewActiveCredItemIndex,
    handleClose,
  } = props;

  const { keyMaterial, credList, setCredList } = useContext(ContextTest);

  return (
    <>
      {!isEditable && !isNewCredItem && (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <button
            onClick={() => setIsEditable(() => !isEditable)}
            style={{ backgroundColor: "#04AA6D", width: "95%" }}
          >
            Edit
          </button>
          <br />
        </Box>
      )}
      {isEditable && (
        <>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <button
              onClick={async () => {
                if (
                  activeCredItem &&
                  (await updateCredItem(
                    keyMaterial,
                    activeCredItem,
                    credListViewActiveCredItemIndex,
                    credList,
                    setCredList
                  ))
                )
                  handleClose();
              }}
              style={{ backgroundColor: "#04AA6D", width: "95%" }}
            >
              Update
            </button>
            <br />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <button
              onClick={async () => {
                if (activeCredItem &&
                  await deleteCredItem(
                    activeCredItem._id,
                    credListViewActiveCredItemIndex,
                    credList,
                    setCredList
                  ))
                handleClose();
              }}
              style={{ backgroundColor: "#f44336", width: "95%" }}
            >
              Delete
            </button>
            <br />
          </Box>
        </>
      )}
      {isNewCredItem && (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <button
            onClick={async () => {
              if (
                await addCredItem(
                  keyMaterial,
                  activeCredItem,
                  credList,
                  setCredList
                )
              )
                handleClose();
            }}
            style={{ backgroundColor: "#04AA6D", width: "95%" }}
          >
            Save
          </button>
          <br />
        </Box>
      )}
    </>
  );
}
